<template></template>

<script>
export default {
  name: "sub_join-module2",
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>